import { Button, Dropdown } from "react-bootstrap"
import SolarMenuDotsBold from "../../icons/SolarMenuDotsBold"
import { useFileNavigator } from "../../../context/FileNavigator"
import SolarRefreshLinear from "../../icons/SolarRefreshLinear"
import { useEffect, useState } from "react"
import UploadFile from "./UploadFile"
import CreateFolder from "./CreateFolder"
import SolarAddFolderLinear from "../../icons/SolarAddFolderLinear"
import SolarUploadMinimalisticLinear from "../../icons/SolarUploadMinimalisticLinear"
import SolarTrashBinMinimalisticLinear from "../../icons/SolarTrashBinMinimalisticLinear"
import DeleteFile from "./DeleteFile"
import SolarClipboardAddOutline from "../../icons/SolarClipboardAddOutline"
import SolarClipboardCheckOutline from "../../icons/SolarClipboardCheckOutline"
import SolarScissorsSquareOutline from "../../icons/SolarScissorsSquareOutline"
import SolarScissorsOutline from "../../icons/SolarScissorsOutline"
import * as apiFN from "../../../api/apiFileNavigator";
import { useToast } from "../../../context/ToastContext"
import { useTranslation } from "react-i18next"
import SvgUpload from "../../icons/svg/SvgUpload"
import SvgFolder from "../../icons/svg/SvgFolder"
import SvgClipCopy from "../../icons/svg/svgClipCopy"
import SvgClipCut from "../../icons/svg/SvgClipCut"
import SvgClipboard from "../../icons/svg/SvgClipboard"
import SvgTrash from "../../icons/svg/SvgTrash"
import SvgReload from "../../icons/svg/SvgReload"
import SvgSetting from "../../icons/svg/SvgSetting"
import CreateFile from "./CreateFile"
import SvgFile from "../../icons/svg/SvgFile"
import SvgLink from "../../icons/svg/SvgLink"
import SvgDownload from "../../icons/svg/SvgDownload"
import { isValidUrl } from "../../../utils/helpers/functions/isValidUrl"
import { useAuth } from "../../../context/AuthContext"
 

const DropdownFileNavigator = ({setProgress}) => {

    const { t } = useTranslation(['FileNavigator']);
    const { auth } = useAuth();
    const isAdmin = Boolean(auth?.user?.admin);
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();
    const { showToast } = useToast();
    const [ targetInputFile, setTargetInputFile]            = useState(false);
    const [ showCreateFolderDlg, setShowCreateFolderDlg ]   = useState(false);
    const [ showCreateFileDlg, setShowCreateFileDlg ]       = useState(false);
    const [ showDelDlg, setShowDelDlg ]                     = useState(false);
    const [ enablePaste, setEnablePaste ]                   = useState(false);
    const [ enableCopyCat, setEnableCopyCat]                = useState(false);
    const [ enableDownload, setEnableDownload]              = useState(false);



    const handleDropdownToggle = async (isOpen, event, metadata) => {
        if (isOpen) {
            const url = await navigator.clipboard.readText()||'';
            console.log(isValidUrl(url))
            setEnableDownload(isValidUrl(url));
        }
    }

    // Завантажуємо файл по юрл з буферу
    const handleClickDownload = async () => {
        dispatchFN({type:'SET_DATA_FN', payload:null});
        const url = await navigator.clipboard.readText();
        const downloadData = { 
            filesUrl    : [url],
            destination :  stateFN.currentPathFN
        }
        const resDownload = await apiFN.downloadUrls(downloadData);
        if (!resDownload) showToast(t('common:messError'),'danger');
        fetchDataFN(true);
    }
 
    // Очищає буфер
    const emplyClip = () => {
        dispatchFN({type:'SET_COPY_FILES', payload: []});
        dispatchFN({type:'SET_CAT_FILES', payload: []});
    }

    // Копіювати - вирізати в буфер обміну
    const handleCopyCatClick = (copy=true) => {
        emplyClip();
        (copy)
            ? dispatchFN({type:'SET_COPY_FILES', payload: stateFN.selectedFiles})
            : dispatchFN({type:'SET_CAT_FILES', payload: stateFN.selectedFiles});

        dispatchFN({type:'TOGGLE_SELECTED', payload:null});
    }

    // Вставити з буферу
    const handlePasteClick = async () => {

        dispatchFN({type:'SET_DATA_FN', payload:null});
 
        // Стуркутруа даних для переміщення або копіювання
        const clipData = {
            oper        : (stateFN?.copyFiles?.length>0) ? 'copy' : 'move',
            files       : (stateFN?.copyFiles?.length>0) ? stateFN?.copyFiles : stateFN?.catFiles,
            destination : stateFN.currentPathFN
        } 

        // Запит на переміщення або копію
        const resPaste = await apiFN.clipPaste(clipData);
        
        const mess  = (clipData.oper=='copy') 
            ? t('messCopiedSuccess') 
            : t('messMovedSuccess');

        if (resPaste) showToast(mess, 'success')
            else showToast(t('messError'), 'danger');

        // Оновлюємо дерефо файлів
        fetchDataFN(true);
        emplyClip();
         
    } 

    useEffect(()=>{
        setEnableCopyCat(stateFN?.selectedFiles?.length>0);
    }, [stateFN.selectedFiles])

    useEffect(()=>{
        setEnablePaste((stateFN?.copyFiles?.length>0) || (stateFN?.catFiles?.length>0))
    }, [stateFN.copyFiles, stateFN.catFiles])
 
 
    return (
        <>
        <Dropdown 
        onToggle={handleDropdownToggle}
        style={{
            marginTop:'-3px',
            height:'24px'
        }}>
            <Dropdown.Toggle
                size="sm"
                className="avtar avtar-xs btn-link-secondary dropdown-toggle arrow-none p-0 text-primary">
                <SvgSetting  style={{height:'22px'}} />
            </Dropdown.Toggle>
 
            <Dropdown.Menu>
                {isAdmin && (
                <Dropdown.Item onClick={()=>setTargetInputFile(!targetInputFile)}>
                    <SvgUpload className="text-muted"/> {t('popupUpload')}
                </Dropdown.Item>
                )}

                <Dropdown.Item onClick={()=>setShowCreateFolderDlg(true)}>
                    <SvgFolder className="text-muted" /> {t('popupCreateFolder')}
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>setShowCreateFileDlg(true)}>
                    <SvgFile className="text-muted" /> {t('popupCreateFilter')}
                </Dropdown.Item>
                
                <Dropdown.Divider />

                <Dropdown.Item onClick={()=>handleCopyCatClick(true)}
                    disabled={!enableCopyCat}>
                    <SvgClipCopy className="text-muted"/> {t('common:clipboard.copy')}
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>handleCopyCatClick(false)}
                    disabled={!enableCopyCat}>
                    <SvgClipCut className="text-muted"/> {t('common:clipboard.cat')}
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>handlePasteClick()}
                    disabled={!enablePaste}>
                    <SvgClipboard className="text-muted"/> {t('common:clipboard.paste')}
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>handleClickDownload()}
                    disabled={!enableDownload}>
                    <SvgDownload className="text-muted"/> {t('popupDownloadUrl')}
                </Dropdown.Item>


                {isAdmin && (
                <>
                <Dropdown.Divider />
                <Dropdown.Item disabled={(stateFN.selectedFiles == null) || (stateFN.selectedFiles?.length<=0)} 
                    onClick={()=>setShowDelDlg(true)}>
                    <SvgTrash className="text-muted" /> {t('popupDelete')}
                </Dropdown.Item>
                </>
                )}
                <Dropdown.Divider />
                <Dropdown.Item onClick={()=>fetchDataFN(true)}>
                    <SvgReload className="text-muted" /> {t('popupReload')}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>

        {isAdmin && (
        <UploadFile targetOpen={targetInputFile}
            setProgress={setProgress}/> 
        )}
        
        <CreateFolder showCreateFolderDlg={showCreateFolderDlg}
            setShowCreateFolderDlg={setShowCreateFolderDlg}/>

        <CreateFile showCreateFileDlg={showCreateFileDlg}
            setShowCreateFileDlg={setShowCreateFileDlg}/>

        {isAdmin && (
        <DeleteFile showDelDlg={showDelDlg} 
            setShowDelDlg={setShowDelDlg}
            fileData={null} />
        )}
        </>
    )
}

export default DropdownFileNavigator;
